export class ThematicBoxEntry {
    constructor(name, visible) {
        this.repr = $(this.html(visible, name));
    }
    html(checked, name) {
        let cursor = checked ? 'default' : 'pointer';
        return `
            <div class="layer${checked ? ' active' : ''}">
                <label style="cursor:${cursor};">
                    <input type="checkbox" id="${name.replace(/\s/g, '')}" name="${name}" ${checked ? 'checked' : ''}>
                    <span style="vertical-align:baseline;margin-left:8px;">${name}</span>
                </label>
                <select>
                    <option value="0">0</option>
                    <option value="0.1">10</option>
                    <option value="0.2">20</option>
                    <option value="0.3">30</option>
                    <option value="0.4">40</option>
                    <option value="0.5">50</option>
                    <option value="0.6">60</option>
                    <option value="0.7">70</option>
                    <option value="0.8">80</option>
                    <option value="0.9">90</option>
                    <option value="1">100</option>
                </select>
            </div>
        `;
    }
    get $select() {
        return this.repr.find('select');
    }
    get $input() {
        return this.repr.find('input:checkbox');
    }
}
